import styled from 'styled-components';
import { animated } from 'react-spring';
import { palette } from "styled-theme";

export const WellContainer = styled(animated.div)`
    background-color: ${palette('error', 5)};
    border-radius: 25px;
    color: ${palette('error', 6)};
    padding: 24px 32px 20px 32px;
    margin: 20px 0;
    overflow: hidden;
`;

export const TitleRow = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 16px;
`;

export const IconWrapper = styled.div`
    margin-right: 12px;
    display: flex;
    align-items: center;
`;

export const Title = styled.div`
    font-weight: 600;
    font-size: 1.1rem;
`;

export const ErrorList = styled.ol`
    margin: 0;
    padding-left: 55px;
`;

export const ErrorItem = styled.li`
    margin-bottom: 6px;
    font-size: 1rem;
    text-decoration: underline;
    list-style: decimal;
`;